import React, { useState, useEffect, useContext } from "react";
import { ShimmerTable } from "react-shimmer-effects";
import { Table, Row, Col, Button, Form } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import Modal from "react-bootstrap/Modal";
import {
  DatatableWrapper,
  Pagination,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import Confirm from "../Confirm";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { SessionContext } from "../SessionProvider";


import { Helmet } from "react-helmet";
import { usePermissions } from "../contexts/PermissionContext";
function Transport(props) {
  const [body, setBody] = useState([]);
  const [showBtn, setShowBtn] = useState(true);
  const [modalBtn, setModalBtn] = useState("Save");
  const [modalShow, setModalShow] = useState(false);
  const [optionVehicals, setoptionVehicals] = useState([]);

  const [showConfirm, setShowConfirm] = useState(false);
  const [distance, setDistance] = useState([]);
  const [reload, setReload] = useState(false);
  const [transport, setTransport] = useState({
    transport_id: "",
    route_direction: "",
    fare_id: "",
    drop_location: "",
  });
  const [selectedId, setSelectedId] = useState(null);
  const { rolePermissions, userInfo } = usePermissions();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const canCreate = rolePermissions?.UserList?.can_create;
  const canEdit = rolePermissions?.UserList?.can_edit;

  const { selectedSessionId, setSelectedSessionId, currentSessionId } = useContext(SessionContext);
  const [isCurrentSession,setIsCurrentSession] = useState();

  useEffect(() => {
    async function init() {
      try {
        if (currentSessionId !== null && currentSessionId !== undefined) {
          setIsCurrentSession(selectedSessionId === currentSessionId);
        }
      } catch (error) {
        console.log('error=>', error);
      }
    }
    init();
  }, [selectedSessionId,isCurrentSession]);

  const header = [
    { title: "Driver Name", prop: "driver_name", isFilterable: true },
    { title: "Vehicle No", prop: "vehicle_no" },
    { title: "Type", prop: "type", isFilterable: true },
    { title: "Distance", prop: "distance" },
    { title: "Fare", prop: "fare_amount" },
    { title: "Location Name", prop: "drop_location", isFilterable: true },
    {
      title: "Action",
      prop: "",
      isFilterable: true,
      show: true,
      cell: (row) => {
        return (
          <>
            <Button
              className="btn-sm mx-2 edit-button"
              variant=""
              disabled={isCurrentSession === false?true:false}
              onClick={() => handleEditButton(row)}
            >
              <i className="fa-regular fa-pen-to-square"></i>
            </Button>
            <Button
              className="btn-sm mx-2"
              style={{ width: "80px" }}
              variant={row.status ? "success" : "danger"}
              disabled={isCurrentSession === false?true:false}
              onClick={() => acctiveRecord(row)}
            >
              {row.status ? "Active" : "Inactive"}
            </Button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    async function init() {
      fetchTransport(props?.student?.id , props?.student?.session_id); // update by sarfraj | 21-Feb-2025

    }
    init();
  }, []);

  const handleEditButton = (row) => {
    setModalShow(true);
    setTransport(row);
    setModalBtn("Update");
  };

  const handleDelete = (row) => {
    setShowDeleteModal(true);
    setSelectedId(row.id);
  };

  const fetchTransport = async (admission_id, sessiond) => {
    try {
      console.log("transport->",transport);
      
      if (transport !== null) {
        
          const assingTransport = await schoolApi.getAssignTransportByIdOrStudentid(admission_id , sessiond); // updated by sarfraj | 21-Feb-2025

        if (assingTransport.success) {
          setBody([assingTransport?.result]);
          setShowBtn(false);
        } else {
          setBody([]);
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    async function init() {
      try {
        let fareList = await schoolApi.getAllFares();
        if (fareList.success) {
          let ar = [];
          fareList?.result?.map((item) => {
            var obj = {};
            obj.value = item.id;
            obj.label = item.uptodistance;
            ar.push(obj);
          });
          setDistance(ar);
        } else {
          setDistance([]);
        }
      } catch (error) {
        toast.error(error.message);
      }
    }
    init();
  }, [reload]);
  useEffect(() => {
    async function init() {
      try {
        let vehicalList = await schoolApi.fetchVehicles();
        if (vehicalList.success) {
          let ar = [];
          vehicalList?.result?.map((item) => {
            var obj = {};
            obj.value = item.id;
            obj.label = item.vehicle_no + " " + item.type;
            ar.push(obj);
          });
          setoptionVehicals(ar);
        } else {
          setoptionVehicals([]);
        }
      } catch (error) {
        toast.error(error.message);
      }
    }
    init();
  }, [reload]);

  const handleClose = () => setModalShow(false);
console.log("props=>", props);


  const handleTransport = () => {
    setModalShow(true);
  };

  const handleChangeSubmit = async (e) => {
    e.preventDefault();
    try {
      if (
        !transport.transport_id ||
        !transport.route_direction ||
        !transport.distance ||
        !transport.drop_location
      ) {
        return toast.error("Missing required fields");
      }

      if (modalBtn === "Update") {
        transport.student_addmission_id = props.student.student_addmission_id; // Add by Abhishek
        transport.fee_type = props.student.fee_type; // Add by Abhishek
        try {
          let transport_update_result = await schoolApi.updateAssignTransport(transport.id, transport);
          if(transport_update_result?.success){
            fetchTransport(props?.student?.id , props?.student?.session_id); // update by sarfraj | 21-Feb-2025
            setModalShow(false);
            toast.success("Record updated succesfully!");
          }
        } catch (error) {
          toast.error("Update Failed!");
        }
      } else {
        if (
          transport.transport_id &&
          transport.transport_id.trim() !== "" &&
          transport.route_direction &&
          transport.route_direction.trim() !== "" &&
          transport.fare_id &&
          transport.fare_id.trim() !== "" &&
          transport.drop_location &&
          transport.drop_location.trim() !== ""
        ) {
          transport.student_addmission_id = props.student.student_addmission_id;
          transport.fee_type = props.student.fee_type; // Add by Abhishek
          transport.sessionid = props.student.session_id;
          let transportFeeByInstall = 0;

          let vehicalList = await schoolApi.createAssignTransport(transport);
          props.student.vehicleid = vehicalList.result.transport_id;
          const inputDate = props.student.dateofbirth;
          const stu_dob = moment(inputDate, "DD-MM-YYYY").format("YYYY-MM-DD");
          props.student.dateofbirth = stu_dob;
          fetchTransport(props?.student?.id , props?.student?.session_id); // update by sarfraj | 21-Feb-2025
          setModalShow(false);
          toast.success("Record Saved Succesfully!");
        } else {
          toast.error("Required field missing!");
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleChange = (e) => {
    let selectedValue = e.target.value;
    if (e.target.name === "fare_id") {
      const selectedLabel =
        distance.find((d) => d.value === selectedValue)?.label || "";
      transport.distance = selectedLabel;
    }
   
   
    if (e.target.name === "status") {
      selectedValue = selectedValue === "true" ? true : false;
    }
    setTransport({
      ...transport,
      [e.target.name]: selectedValue,
    });
   
   
  };

  const handleDeleteModuleRecord = async () => {
    if (selectedId) {
      try {
        const result = await schoolApi.deleteAssignTransport(selectedId);
        props.student.vehicleid = null;
        const updatedStudent = await schoolApi.updateStudent(props.student);
        setShowDeleteModal(false);
        setSelectedId(null);
        setBody([]);
        setShowBtn(true);
        toast.success("Record Deleted successfully!");
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          toast.error(error.response.data.errors);
        } else {
          toast.error("Unknown error occurred. Please try again.");
        }
      }
    }
  };
  const acctiveRecord = (row) => {
    if (
      canEdit ||
      userInfo?.userrole === "SYS_ADMIN" ||
      userInfo?.userrole === "ADMIN"
    ) {
      const updatedRow = {
        ...row,
        status: row.status,
      };
      setTransport(updatedRow);
      setShowConfirm(true);
    }
  };


  const confirmAction = async () => {
    try {
      const updatedStatus = transport.status ? false : true;

      const updatedRecord = {
        ...transport,
        status: updatedStatus,
      };

      const response = await schoolApi.updateAssignTransport(
        updatedRecord.id,
        updatedRecord
      );

      if (response.success) {
        toast.success(response.message);
        // fetchTransport(props?.student?.student_addmission_id);
        fetchTransport(props?.student?.id , props?.student?.session_id); // update by sarfraj | 21-Feb-2025
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Internal Server Error");
    } finally {
      setShowConfirm(false);
      setTransport(null);
    }
  };
  return (
    <div>
      {showDeleteModal && (
        <Confirm
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          deleteAssignTransport={() => handleDeleteModuleRecord()}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="assign_transport"
        />
      )}
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      {showBtn && (
        <Row className="mr-3">
          <Col className="d-flex justify-content-end">
            <Button
              className="btn-sm mx-2 mt-3 mb-3 me-2 btnHover"
              variant="primary"
              size="sm"
              disabled={isCurrentSession === false?true:false}
              onClick={handleTransport}
            >
              Create Transport
            </Button>
          </Col>
        </Row>
      )}
      <Row className="mt-2">
        <Col lg={12}>
          {body ? (
            body.length > 0 ? (
              <DatatableWrapper body={body} headers={header}>
                <Table striped className="data-table custom-table-subject-list">
                  <TableHeader />
                  <TableBody />
                </Table>
                <Pagination />
              </DatatableWrapper>
            ) : (
              <div>
                <DatatableWrapper body={body} headers={header}>
                  <Table
                    striped
                    className="data-table custom-table-subject-list"
                  >
                    <TableHeader />
                    <TableBody>
                      <tr>
                        <td colSpan={header.length} className="text-center">
                          No Records Found!!!
                        </td>
                      </tr>
                    </TableBody>
                  </Table>
                  <Pagination />
                </DatatableWrapper>
              </div>
            )
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
      </Row>
      {showConfirm && (
        <Confirm
          show={showConfirm}
          onHide={() => setShowConfirm(false)}
          status={confirmAction}
          title="Confirm Status Change"
          message={`Are you sure you want to ${
            !transport?.status ? "Active" : " Inactive"
          } this transport?`}
          table="assign_transport"
        />
      )}
      <Modal
        show={modalShow}
        onHide={handleClose}
        backdrop="static"
        centered
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          <Modal.Title>Transport</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-view-label">Vehicle</Form.Label>
                  <Form.Select
                    name="transport_id"
                    onChange={handleChange}
                    value={transport?.transport_id}
                    required
                  >
                    <option value="">Select Vehicle</option>
                    {optionVehicals.map((vehicle, index) => (
                      <option key={index} value={vehicle.value}>
                        {vehicle.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-view-label">
                    Transport way{" "}
                  </Form.Label>
                  <Form.Select
                    name="route_direction"
                    value={transport?.route_direction}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Select Transport way --</option>
                    <option value="One way">One way</option>
                    <option value="Two way">Two way</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-view-label">
                    Distance(km)
                  </Form.Label>
                  <Form.Select
                    name="fare_id"
                    onChange={handleChange}
                    value={transport?.fare_id}
                    required
                  >
                    <option value="">Select Distance</option>
                    {distance.map((distance, index) => (
                      <option key={index} value={distance.value}>
                        {distance.label}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              {}
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="form-view-label">Status </Form.Label>
                  {console.log("transport?.status", transport?.status)}
                  <Form.Select
                    name="status"
                    value={transport?.status}
                    onChange={handleChange}
                    required
                  >
                    <option value="">-- Select Status --</option>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group>
                  <Form.Label className="form-view-label">
                    Drop Location
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="drop_location"
                    placeholder="Enter drop location"
                    value={transport?.drop_location}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleChangeSubmit}>
            {modalBtn}
          </Button>
        </Modal.Footer>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </Modal>
    </div>
  );
}

export default Transport;